<template>
  <v-dialog v-model="display" @input="input" persistent :max-width="maxwidth">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="button.handler"
               :color="button.color"
               v-for="button in buttons"
               flat
               :key="button.label">
          {{button.label}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmation',
  props: {
    title: {
      type: String,
      require: true
    },
    message: {
      type: String,
      require: true
    },
    buttons: {
      type: Array,
      require: true
    },
    maxwidth: {
      type: String,
      require: false,
      default: '500'
    }
  },
  data () {
    return {
      display: false
    }
  },
  methods: {
    show () {
      this.display = true
    },
    close () {
      this.display = false
    },
    input () {
      this.$emit('input')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/Confirmation.vue